import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ResultsEmptyState.module.scss';

type ResultsEmptyStateProps = {
  title?: string;
  message?: string;
  resetButton?: ReactNode;
};

export const ResultsEmptyState = ({
  title,
  message,
  resetButton,
}: ResultsEmptyStateProps) => {
  const { t } = useTranslation(['screener']);

  return (
    <div className={styles.container} data-testid="no-results">
      <img
        src="/app/static/images/icons/no-assets-found.svg"
        alt="no assets found"
      />
      <p className={styles.title}>{title ?? t('screener:emptyTitle')}</p>
      <p className={styles.message}>{message ?? t('screener:emptyMessage')}</p>
      {resetButton}
    </div>
  );
};
